import React from 'react';
import { Grid, Card, CardContent, Typography, Box, Chip } from '@mui/material';

const TemplateInfoCard = ({ selectedTemplate }) => {
  if (!selectedTemplate) {
    return null;
  }

  return (
    <Grid size={{ xs: 12 }}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle2" gutterBottom>
            Selected Template
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {selectedTemplate.description || 'No description available'}
          </Typography>
          <Box sx={{ mt: 1 }}>
            <Chip label={selectedTemplate.category} size="small" />
            <Chip label={selectedTemplate.status} size="small" sx={{ ml: 1 }} />
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TemplateInfoCard;
